/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
import { baseActions } from "document-model";
import {
  appModuleBaseOperationsActions,
  appModuleDndOperationsActions,
} from "./gen/creators.js";

/** Actions for the AppModule document model */

export const actions = {
  ...baseActions,
  ...appModuleBaseOperationsActions,
  ...appModuleDndOperationsActions,
};
